import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
@Injectable({
  providedIn: 'root'
})
export class CbtService {
  submitted = false;
  scoreDetails = [];
  examTobeTaken = null
  private emitChangeSource = new BehaviorSubject<any>({ scoreDetails: this.scoreDetails });
  public examStudentImage = new BehaviorSubject<any>("no-image");
  changeEmitted$ = this.emitChangeSource.asObservable();
  public examModeDetails = new BehaviorSubject<any>(null);

  constructor(private http: HttpClient) {
  }

  emitChange(details) {
    let x = { scoreDetails: [] };
    x.scoreDetails = details;
    this.emitChangeSource.next(x);
  }

  cbtAction(data) {
    return this.http.post<any>("/edozzier/portal-cbt.php", data);
  }

  submitExam(data) {
    return this.http.post<any>("/edozzier/portal-submit-cbt.php", data);
  }

  saveProgress(data) {
    return this.http.post<any>("/edozzier/portal-save-exam-progress.php", data);
  }

  loadExamCategories(data) {
    return this.http.post<any>("/edozzier/portal-cbt.php", data);
  }
  examInitialSummary(data) {
    return this.http.post<any>("/edozzier/portal-cbt.php", data);
  }

  isSubmitted() {
    return this.http.get<any>("/edozzier/portal-exam-submitted.php");
  }

  checkInvigilatorCode(data) {
    return this.http.post<any>("/edozzier/portal-checkInvigilatorCode.php", data);
  }

  keepOffence(data) {
    return this.http.post<any>("/edozzier/portal-updateOffences.php", data);
  }

  keepStudentVirtualExamImage(data) {
    return this.http.post<any>("/edozzier/portal-studentExamImage.php", data);
  }

}
